import { render, staticRenderFns } from "./StoriesModal.vue?vue&type=template&id=10c5f642&scoped=true"
import script from "./StoriesModal.vue?vue&type=script&lang=ts"
export * from "./StoriesModal.vue?vue&type=script&lang=ts"
import style0 from "./StoriesModal.vue?vue&type=style&index=0&id=10c5f642&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5f642",
  null
  
)

export default component.exports